import Navbar from "./components/Navbar";
import "./style.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Career from "./components/Career";
import Portfolio from "./components/Portfolio";
import Blog from "./components/Blog";
import PageNotFound from "./components/PageNotFound";
import PreviewBlog from "./components/PreviewBlog";
import EditPortfolio from "./components/EditPortfolio";
import EditBlog from "./components/EditBlog";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Technologie from "./components/Technologie";
import ContactList from "./components/ContactList"; // Add this import
import PortfolioSequence from "./components/PortfolioSequence"; // Add this import
import News from "./components/News";
import PreviewNews from "./components/PreviewNews";
import EditNews from "./components/EditNews";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Navbar />}>
              <Route index element={<Blog />} />
              <Route path="career" element={<Career />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="portfolio/:id" element={<EditPortfolio />} />
              <Route path="preview" element={<PreviewBlog />} />
              <Route path="blog/:id" element={<EditBlog />} />
              <Route path="technologie" element={<Technologie />} />
              <Route path="contact" element={<ContactList />} /> {/* Add this line */}
              <Route path="portfolio-sequence" element={<PortfolioSequence />} /> {/* Add this line */}
              <Route path="news" element={<News />} />
              <Route path="news/preview" element={<PreviewNews />} />
              <Route path="news/:id" element={<EditNews />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
